module.exports = "/static/assets/a1cf2da558bd031749a8ea8d0d3a3e25.png";